export default "__VITE_PUBLIC_ASSET__0ead7d43__"